import { baseAdminService } from '../apis/baseService/baseAdminService';
import { baseService } from '../apis/baseService/baseService';

const fileExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'zip', 'mov', 'mp4', 'jpeg', 'jpg', 'png'];

const getNameWithoutDots = (url: string, filename?: string): string =>
  ((filename || url.split('/').slice(-1)[0]?.split('?')[0]) ?? 'file')
    .split('.')
    .map((name) => (fileExtensions.includes(name) ? `.${name}` : name))
    .join('');

const simulatedUserInteraction = (link: HTMLAnchorElement): void => {
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const downloadFile = async (url: string, onError: () => void, filename?: string): Promise<void> => {
  if (!url) return Promise.resolve();

  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = getNameWithoutDots(url, filename);
    simulatedUserInteraction(link);
  } catch {
    onError();
  }
};

export const downloadVideo = async (
  url: string,
  onError: () => void,
  fileName: string,
  format: string,
  isAdmin: boolean
): Promise<void> => {
  if (!url) return;

  const service = isAdmin ? baseAdminService : baseService;
  await service
    .get(url, { responseType: 'blob' })
    .then(({ data }) => {
      const newBlob = new Blob([data], { type: `video/${format}` });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(newBlob);
      const nameForFile = fileName.replace(/\./g, '');
      link.download = format === 'mov' ? `${nameForFile}.mov` : nameForFile;
      simulatedUserInteraction(link);
    })
    .catch(() => {
      onError();
    });
};

export const downloadInvoice = async (
  url: string,
  onError: () => void,
  fileName: string,
  isView: boolean,
  isAdmin: boolean
): Promise<void> => {
  if (!url) return;

  const service = isAdmin ? baseAdminService : baseService;
  await service
    .get(url, { responseType: 'blob' })
    .then(({ data }) => {
      const newBlob = new Blob([data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = URL.createObjectURL(newBlob);
      if (!isView) link.download = fileName;
      simulatedUserInteraction(link);
    })
    .catch(() => {
      onError();
    });
};
